module.exports = __webpack_public_path__ + "img/group.52647a02.svg";